import type { MiniGameResult, RpsPick } from './types';

type Rng = () => number;

const ALL: RpsPick[] = ['rock', 'paper', 'scissors'];

export function randomRpsPick(rng: Rng = Math.random): RpsPick {
  return ALL[Math.min(Math.floor(rng() * ALL.length), ALL.length - 1)]!;
}

export function resolveRps(player: RpsPick, cpu: RpsPick): MiniGameResult {
  if (player === cpu) return 'draw';
  if (
    (player === 'rock' && cpu === 'scissors') ||
    (player === 'paper' && cpu === 'rock') ||
    (player === 'scissors' && cpu === 'paper')
  ) {
    return 'win';
  }
  return 'lose';
}

export function rpsReward(r: MiniGameResult): number {
  return r === 'win' ? 12 : r === 'draw' ? 5 : 0;
}
